import { track } from "jiffy-analytics";

export function hasFlashDelivery($badge) {
  if (!$badge) return false;
  const text = $badge.textContent.toLowerCase();
  return text.includes("today") || text.includes("tomorrow");
}

export function detectDeliveryTypes($productCards) {
  let hasSameDay = false;
  let hasNextDay = false;

  // If no product cards or empty NodeList, return false for both
  if (!$productCards || $productCards.length === 0) {
    return { hasSameDay, hasNextDay };
  }

  $productCards.forEach($card => {
    // Check if card is truly visible (not hidden by parent sections)
    const $parentSection = $card.closest(".products__list, section[data-section]");
    const isParentHidden =
      $parentSection &&
      ($parentSection.classList.contains("hidden") || $parentSection.style.display === "none");

    // Skip if card or its parent section is hidden
    if (isParentHidden || !$card.offsetParent || $card.style.display === "none") return;
    const $badge = $card.querySelector(".js-same-day-badge");
    if ($badge && $badge.textContent) {
      const text = $badge.textContent.toLowerCase();
      if (text.includes("today")) hasSameDay = true;
      else if (text.includes("tomorrow")) hasNextDay = true;
    }
  });

  return { hasSameDay, hasNextDay };
}

export function updateFilterDisplay(hasSameDay, hasNextDay) {
  const $getFilter = () => document.querySelector(".js-same-day-filter");
  const $getText = () => document.querySelector(".js-same-day-filter-text");

  const $filter = $getFilter();
  if (!$filter) return;

  // Hide filter if no delivery data is available
  if (!hasSameDay && !hasNextDay) {
    $filter.classList.add("hidden");
    return;
  }

  // Show filter and update text
  $filter.classList.remove("hidden");

  const $text = $getText();
  if ($text) {
    let labelText = "";
    if (hasSameDay && hasNextDay) {
      labelText = "Show All Next/Same Day Delivery";
    } else if (hasSameDay) {
      labelText = "Show All Same Day Delivery";
    } else if (hasNextDay) {
      labelText = "Show All Next Day Delivery";
    }
    $text.textContent = labelText;
  }
}

export function handleSameDayFilter(isActive, $productCards) {
  track("same_day_filter_toggled", { enabled: isActive });

  $productCards.forEach($card => {
    const $badge = $card.querySelector(".js-same-day-badge");
    $card.style.display = isActive && !hasFlashDelivery($badge) ? "none" : "";
  });

  updateSectionVisibility();
}

export function updateSectionVisibility() {
  const $sections = document.querySelectorAll(".products__list");

  $sections.forEach($section => {
    const $visibleProducts = $section.querySelectorAll(
      ".js-products__item:not([style*='display: none'])"
    );
    const hasVisibleProducts = $visibleProducts.length > 0;

    if ($section.classList.contains("js-dtf-category") && !hasVisibleProducts) {
      $section.style.display = "none";
    } else if ($section.classList.contains("js-dtf-category")) {
      $section.style.display = "";
    }
  });
}

export function createBadgeObserver(callback) {
  let pending = false;
  return new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      callback();
      pending = false;
    });
  });
}

export function observeProductCards($productCards, observer) {
  $productCards.forEach($card => {
    observer.observe($card, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  });
}

// Cleanup manager to handle observer lifecycle
let activeCleanup = null;

export function resetSameDayFilter(options) {
  const { $checkbox, isActive, observer, setupCallback } = options;

  // Always reset the filter state when changing categories
  if ($checkbox && isActive) {
    track("same_day_filter_reset", { reason: "category_change" });
  }

  // Cancel any pending cleanup
  if (activeCleanup) {
    activeCleanup();
    activeCleanup = null;
  }

  // Clean up existing observer
  if (observer) {
    observer.disconnect();
  }

  // Use requestAnimationFrame for DOM update instead of setTimeout
  const rafId = requestAnimationFrame(() => {
    setupCallback();
  });

  // Store cleanup function
  activeCleanup = () => {
    cancelAnimationFrame(rafId);
  };

  return false;
}

// Tab management helpers
export function setActiveTab(tabName, $mostPopularTab, $allProductsTab) {
  const isMostPopular = tabName === "most-popular";
  $mostPopularTab?.classList.toggle("active", isMostPopular);
  $allProductsTab?.classList.toggle("active", !isMostPopular);
}

export function setSectionVisibility(
  { mostPopular, others },
  $mostPopularSection,
  $allOtherSections
) {
  $mostPopularSection?.classList.toggle("hidden", !mostPopular);
  $allOtherSections.forEach($section => {
    $section.classList.toggle("hidden", !others);
  });
}

export function handleHashNavigation($tabHeader, viewCallback) {
  if (!$tabHeader) return;
  const currentHash = window.location.hash.substring(1);
  viewCallback(currentHash === "most-popular" ? "most-popular" : "all-products");
}
